import { OrgNode } from '@/components/organization/InteractiveOrgChart';

/**
 * 조직도 노드와 그 하위 모든 노드의 ID를 수집하는 함수
 * 
 * @param node 조직도 노드
 * @returns 모든 하위 노드 ID 배열
 */
export const collectAllNodeIds = (node: OrgNode): string[] => {
  let ids: string[] = [node.id];

  if (node.children && node.children.length > 0) {
    node.children.forEach(child => {
      ids = [...ids, ...collectAllNodeIds(child)];
    });
  }

  return ids;
};

/**
 * 특정 노드 ID의 모든 하위 노드 ID를 수집하는 함수
 * 
 * @param nodes 조직도 노드 배열
 * @param targetId 대상 노드 ID
 * @returns 대상 노드와 모든 하위 노드 ID 배열
 */
export const findSubtreeNodeIds = (nodes: OrgNode[], targetId: string): string[] | null => {
  for (const node of nodes) {
    if (node.id === targetId) {
      return collectAllNodeIds(node);
    }

    if (node.children) {
      const result = findSubtreeNodeIds(node.children, targetId);
      if (result) {
        return result;
      }
    }
  }

  return null;
};